import styled from 'styled-components'
import breakpoints from '../../../../config/Breakpoints'

import CardTitle from '../../../../common/styles/CardTitle'
import useSourceDistribution from '../hooks/useSourceDistribution'
import LoadingBar from '../../../../common/LoadingBar'

const BookStatisticsSourceCard = () => {
	const [data, total, isLoading] = useSourceDistribution()

	const getPercent = (count: number): string => {
		if (total === 0) return '0%'
		const p = (count / total) * 100
		if (count === 0) return '0%'
		return `${p < 1 ? p.toFixed(1) : p.toFixed(0)}%`
	}

	const rows = [
		{label: '새 책 (오프라인)', value: data?.buyNewOffline ?? 0},
		{label: '새 책 (온라인)', value: data?.buyNewOnline ?? 0},
		{label: '중고 (오프라인)', value: data?.buyUsedOffline ?? 0},
		{label: '중고 (온라인)', value: data?.buyUsedOnline ?? 0},
		{label: '도서관', value: data?.library ?? 0},
		{label: '서점 대여', value: data?.borrowStore ?? 0},
		{label: '지인 대여', value: data?.borrowFriends ?? 0},
		{label: '구독', value: data?.subscription ?? 0},
		{label: '기타', value: data?.others ?? 0},
		{label: '미입력', value: data?.notProvided ?? 0},
	]

	return (
		<Container>
			
				<CardTitle icon={null} mb={0} title={'출처별 비율'} url={''} textSize={5}/>

				<Table>
					<tbody>
						{rows.map((row, i) => (
							<tr key={i}>
								<Th>{row.label}</Th>
								<Td>
									{isLoading ? (
										<LoadingValue>
											<LoadingBar size={3}/>
										</LoadingValue>
									) : (
										<ValueContainer>
											<CountValue>{row.value}</CountValue>
											{getPercent(row.value) && <ExtraValue>{getPercent(row.value)}</ExtraValue>}
										</ValueContainer>
									)}
								</Td>
							</tr>
						))}
					</tbody>
				</Table>
			
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	min-height: 650px;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;

	@media (max-width: ${breakpoints.md}) {
		height: auto;
		min-height: 0;
	}
`

const Table = styled.table`
	margin: 0;
	width: 100%;

	tbody {
		background-color: transparent !important;
	}

	tr {
		border-radius: 8px;

		&:hover {
			background-color: var(--hover-bg-color);
		}
	}
`

const Th = styled.th`
	padding: 10px 8px;
	color: var(--text-color);
	font-size: 1.1rem;
	font-weight: normal;
	border-bottom: 1px solid var(--hover-bg-color);
`

const Td = styled.td`
	padding: 10px 8px;
	color: var(--text-color);
	border-bottom: 1px solid var(--hover-bg-color);
	text-align: right;
`

const LoadingValue = styled.div`
	height: 32px;
	display: flex;
	align-items: center;
`

const ValueContainer = styled.h5.attrs({className: 'd-flex flex-row justify-content-end'})`
	margin: 0;
	height: 32px;
`

const CountValue = styled.span`
	min-width: 40px;
	text-align: right;
	margin-right: 5px;
`

const ExtraValue = styled.div`
	padding-top: 7px;
	margin: 0;
	font-size: 14px;
	color: var(--sub-text-color);
	min-width: 45px;
	text-align: right;
`

export default BookStatisticsSourceCard
